import React from 'react';

import CurrencySign from 'components/price/CurrencySign.component';

const ProcedureReview = (props) => {
  if (!props.procedure.service) {
    return null;
  }
  return (
    <div className="procedure">
      <span
        className="dot-color"
        style={{
          backgroundColor: props.procedure.service.category.color,
        }}
      />
      <div>
        <span className="stylist">
          {props.procedure.service.name}
          {props.showStylist && <span> {`with ${props?.procedure?.stylist?.user_name}`}</span>}
        </span>

        <span className="price">
          <CurrencySign />
          {props.procedure.price}
        </span>
      </div>
    </div>
  );
};

export default ProcedureReview;
